import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from '@redux-devtools/extension';

import { isDev } from 'services/env-service';

import appReducer from './reducers';
import rootSaga from './sagas';

// A redux middleware that tracks redux actions
const timingMiddleware = () => (next) => (action) => {
    if (performance.mark === undefined) return next(action);

    performance.mark(`${action.type}_start`);
    const result = next(action);
    performance.mark(`${action.type}_end`);
    performance.measure(
        action.type,
        `${action.type}_start`,
        `${action.type}_end`
    );

    return result;
};

const sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware, timingMiddleware];
const rootReducer = (state, action) => {
    if (action.type === 'RESET_STORE' || action.type === 'LOGOUT') {
        state = undefined;
    }

    return appReducer(state, action);
}
const composeEnhancers = isDev() ? composeWithDevTools({}) : compose;

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(...middleware)
));

sagaMiddleware.run(rootSaga);

export default store;
